"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePasswordRules = void 0;
const validatePasswordRules = (password) => {
    const errors = [];
    if (password.length <= 5) {
        errors.push('Password must be longer then 5 characters');
    }
    return errors;
};
exports.validatePasswordRules = validatePasswordRules;
//# sourceMappingURL=validatePasswordRules.js.map